wbApp.controller('MyActivitiesBookDetailCtrl', ['$scope', '$translate', 'activityAttendanceSvc', 'messageBoxSvc',
function ($scope, $translate, activityAttendanceSvc, messageBoxSvc) {

    $scope.isSaving = false;

    function finalizeSave(schedule) {
        schedule.studentID = $scope.selectedStudent.studentID;

        var res = activityAttendanceSvc.saveAttendanceAsync(schedule, true);

        res.$promise.then(function (data) {
            var newAttendanceByActivityScheduleID = _.keyBy(data, 'activityScheduleID');

            _.forEach($scope.scheduleMonths, function (month) {
                for (var s = 0; s < month.schedules.length; s++) {
                    var schedule = month.schedules[s];
                    var newSchedule = newAttendanceByActivityScheduleID[schedule.activityScheduleID];
                    if (!!newSchedule) {
                        var differs =
                            schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                            schedule.firstPeriodAttendanceStatusID !== newSchedule.firstPeriodAttendanceStatusID ||
                            schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                            schedule.secondPeriodAttendanceStatusID !== newSchedule.secondPeriodAttendanceStatusID ||
                            schedule.numberOfExcuses !== newSchedule.numberOfExcuses ||
                            schedule.firstPeriodFilled !== newSchedule.firstPeriodFilled ||
                            schedule.secondPeriodFilled !== newSchedule.secondPeriodFilled ||
                            schedule.firstPeriodWaitQueuePosition !== newSchedule.firstPeriodWaitQueuePosition ||
                            schedule.secondPeriodWaitQueuePosition !== newSchedule.secondPeriodWaitQueuePosition;

                        if (differs) {
                            month.schedules[s] = newSchedule;
                        }
                    }
                }
            });

            for (var s = 0; s < $scope.studentAttendanceData.length; s++) {
                var schedule = $scope.studentAttendanceData[s];
                var newSchedule = newAttendanceByActivityScheduleID[schedule.activityScheduleID];
                if (!!newSchedule) {
                    var differs =
                        schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                        schedule.firstPeriodAttendanceStatusID !== newSchedule.firstPeriodAttendanceStatusID ||
                        schedule.firstPeriodAttendanceTypeID !== newSchedule.firstPeriodAttendanceTypeID ||
                        schedule.secondPeriodAttendanceStatusID !== newSchedule.secondPeriodAttendanceStatusID ||
                        schedule.numberOfExcuses !== newSchedule.numberOfExcuses ||
                        schedule.firstPeriodFilled !== newSchedule.firstPeriodFilled ||
                        schedule.secondPeriodFilled !== newSchedule.secondPeriodFilled ||
                        schedule.firstPeriodWaitQueuePosition !== newSchedule.firstPeriodWaitQueuePosition ||
                        schedule.secondPeriodWaitQueuePosition !== newSchedule.secondPeriodWaitQueuePosition;

                    if (differs) {
                        $scope.studentAttendanceData[s] = newSchedule;
                    }
                }
            };

            $scope.$hide();
            $scope.bookModal.onSave();
            $scope.isSaving = false;
        }, function (err) {
            $scope.isSaving = false;
        });
    }

    $scope.onAttendanceBookConfirmClick = function (schedule) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (schedule.hasNewWaitQueue) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_CONFIRMATION',
                message: schedule.isOneOffAttendanceEnabled 
                    ? $translate.instant('TXT_NEW_WAIT_QUEUE_CONFIRMATION') + $translate.instant('TXT_NEW_WAIT_QUEUE_CONFIRMATION_ONE_OFF')
                    : $translate.instant('TXT_NEW_WAIT_QUEUE_CONFIRMATION'),
                buttons: [{
                    text: 'TXT_BTN_NO'
                }, {
                    text: 'TXT_BTN_YES',
                    callback: function () {
                        finalizeSave(schedule);                        
                    }
                }]
            });
        }
        else {
            if (schedule.hasNewOneOff) {
                messageBoxSvc.showMessageDlg({
                    title: 'TXT_TITLE_CONFIRMATION',
                    message: 'TXT_NEW_ONE_OFF_CONFIRMATION',
                    buttons: [{
                        text: 'TXT_BTN_NO'
                    }, {
                        text: 'TXT_BTN_YES',
                        callback: function () {
                            finalizeSave(schedule);                            
                        }
                    }]
                });
            } else {
                finalizeSave(schedule);               
            }
        }
    }
}]);
